import Constants from "~/helpers/enums/Constants";

const initialState = {
	selectedServices: [],
	availablePackages: [],
	recommendedPackages: [],
	loading: false,
	error: null,
	showPackageOffer: false,
	acceptedPackage: null,
};

const checkoutPackageOfferReducer = (state = initialState, action = null) => {
	switch (action.type) {
		case Constants.SET_SELECTED_SERVICES:
			return {
				...state,
				selectedServices: action.payload.selectedServices,
			};

		case Constants.SET_AVAILABLE_PACKAGES:
			return {
				...state,
				availablePackages: action.payload.availablePackages,
				recommendedPackages: [],
				loading: false,
				error: null,
			};

		case Constants.SET_RECOMMENDED_PACKAGES:
			return {
				...state,
				recommendedPackages: action.payload.recommendedPackages,
				showPackageOffer: action.payload.recommendedPackages.length > 0,
			};

		case Constants.SET_LOADING_PACKAGE_OFFER:
			return {
				...state,
				loading: action.payload.loading,
			};

		case Constants.SET_ERROR_PACKAGE_OFFER:
			return {
				...state,
				error: action.payload.error,
				loading: false,
			};

		case Constants.SET_SHOW_PACKAGE_OFFER:
			return {
				...state,
				showPackageOffer: action.payload.showPackageOffer,
			};

		case Constants.ACCEPT_PACKAGE_OFFER:
			return {
				...state,
				acceptedPackage: action.payload.acceptedPackage,
				showPackageOffer: false,
			};

		case Constants.DECLINE_PACKAGE_OFFER:
			return {
				...state,
				showPackageOffer: false,
			};

		case Constants.CLEAR_PACKAGE_OFFERS:
			return {
				...state,
				availablePackages: [],
				recommendedPackages: [],
				showPackageOffer: false,
				acceptedPackage: null,
			};

		default:
			return state;
	}
};

export default checkoutPackageOfferReducer;